/**
 * Extrai informações dos formulários de um lead com suas respostas organizadas
 * @param {Object} lead - Objeto lead com suas respostas de formulário
 * @returns {Array} Array de objetos contendo informações dos formulários respondidos
 */
function extractLeadFormResponses(lead) {
    if (!lead || !lead.formResponses || !Array.isArray(lead.formResponses)) {
        return []
    }

    // Mapeia os formulários únicos a partir das respostas
    const formMap = new Map()

    // Primeiro passo: identificar todos os formulários únicos
    lead.formResponses.forEach((response) => {
        if (response.question && response.question.form) {
            const formId = response.question.form.id

            if (!formMap.has(formId)) {
                // Criar uma entrada para este formulário
                formMap.set(formId, {
                    id: formId,
                    title: response.question.form.title,
                    description: response.question.form.description,
                    product: response.question.form.product,
                    utm_source: response.plaftorm,
                    questions: [],
                    responses: [],
                })
            }

            // Adicionar a resposta a este formulário
            const form = formMap.get(formId)

            // Verificar se a questão já existe no array de questões
            const existingQuestion = form.questions.find(
                (q) => q.id === response.question.id,
            )
            if (!existingQuestion) {
                form.questions.push({
                    id: response.question.id,
                    text: response.question.questionText,
                    type: response.question.type,
                    options: response.question.questionOptions
                        ? JSON.parse(response.question.questionOptions)
                        : [],
                })
            }

            // Formatar a resposta com base no tipo de pergunta
            let formattedAnswer = response.textAnswer

            if (response.question.type === "single_select") {
                const options = JSON.parse(
                    response.question.questionOptions || "[]",
                )
                const selectedOption = options.find(
                    (opt) => opt.id.toString() === response.textAnswer,
                )
                formattedAnswer = selectedOption
                    ? selectedOption.label
                    : response.textAnswer
            } else if (response.question.type === "multi_select") {
                try {
                    const selectedIds = JSON.parse(response.textAnswer)
                    const options = JSON.parse(
                        response.question.questionOptions || "[]",
                    )
                    formattedAnswer = selectedIds.map((id) => {
                        const option = options.find((opt) => opt.id === id)
                        return option ? option.label : id
                    })
                } catch (e) {
                    // Manter o valor original se não for possível fazer o parse
                }
            }

            form.responses.push({
                questionId: response.question.id,
                questionText: response.question.questionText,
                rawAnswer: response.textAnswer,
                formattedAnswer: formattedAnswer,
                createdAt: response.createdAt,
            })
        }
    })

    // Converter o Map para Array e ordenar as respostas por data de criação
    return Array.from(formMap.values()).map((form) => {
        form.responses.sort(
            (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
        )
        return form
    })
}

export default extractLeadFormResponses
